import * as Sentry from "@sentry/react";
import { supabase } from "@/integrations/supabase/client";

let initialized = false;

export function initSentry() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  const dsn = import.meta.env.VITE_SENTRY_DSN || "https://37fb4a101babba4db53c2a9c3743ce3d@o4511714862891008.ingest.us.sentry.io/4511714872852480";
  if (!dsn) return;
  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
  initialized = true;

  try {
    supabase.auth.getSession().then(({ data }) => {
      const u = data.session?.user;
      if (u) Sentry.setUser({ id: u.id, email: u.email ?? undefined });
    });
    supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT") {
        Sentry.setUser(null);
        return;
      }
      const u = session?.user;
      if (u) Sentry.setUser({ id: u.id, email: u.email ?? undefined });
    });
  } catch {
    /* non-fatal */
  }
}

export { Sentry };
